import { useCallback } from "react";

import OptionInput from "./OptionInput";
import inputConnect from "./inputConnect";

const CheckBoxInput = props => {
  const { fieldName, label, checked, updateValue } = props;

  const handleChange = useCallback(
    e => {
      const { checked } = e.target;

      updateValue({ checked });
    },
    [updateValue]
  );

  return (
    <div className="checkbox-input check-boxes">
      <OptionInput
        type="checkbox"
        option={{ name: label }}
        name={fieldName}
        checked={checked}
        onChange={handleChange}
      />
    </div>
  );
};

export default inputConnect(CheckBoxInput, {
  fields: { checked: false }
});
